export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
  },
  {
    title: '结算日期',
    field: 'settlementDate',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: '运输模式',
    field: 'v_transportMode',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: '车型需求',
    field: 'v_vehicleModel',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: '单量',
    field: 'waybillVolume',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: '始发地省份名称',
    field: 'originProvinceName',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: '始发地城市名称',
    field: 'originCityName',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: '始发地区县名称',
    field: 'originDistrictName',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: '目的地省份名称',
    field: 'destinationProvinceName',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: '目的地城市名称',
    field: 'destinationCityName',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: '目的地区县名称',
    field: 'destinationDistrictName',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: '应收运费合计',
    field: 'incomeAmount',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: '应收费用合计',
    field: 'incomeCostAmount',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
    slots:{
      default:'incomeCostAmount'
    }
  },
  // {
  //   title: '应收费用明细',
  //   field: 'incomeCostDetail',
  //   headerAlign: 'center',
  //   align: 'center',
  //   width: 100,
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  {
    title: '应收合计',
    field: 'incomeTotalAmount',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
